.an{justify-content:center;}